import { COOKIE_GDPRC } from "../../shared/global/variables";
let loc = window.location;

function popupCookies() {
	const cookieModule = document.querySelector(
			'[data-js-module="popup-cookies"]'
		),
		cookiesBelt = document.querySelector('[data-js="cookies-belt"]');

	if (cookieModule) {
		const agreeBtn1 = cookieModule.querySelector('[data-js="agree-btn-1"]'),
			agreeBtn2 = cookieModule.querySelector('[data-js="agree-btn-2"]'),
			disagreeBtns = cookieModule.querySelectorAll('[data-js="disagree-btn"]'),
			apiUrl = cookieModule.getAttribute("api-url"),
			token = cookieModule.getAttribute("api-data"),
			session = sessionStorage.getItem("hide"),
			publicationDate = cookieModule.getAttribute("exp-date");

		window.onload = checkCookie(cookieModule, cookiesBelt, publicationDate);

		if (session === "true") {
			cookiesBelt.classList.remove("is-active");
		}

		agreeBtn1.addEventListener("click", () => {
			cookieModule.classList.remove("is-active");
			checkToken(apiUrl, token, COOKIE_GDPRC, 1, 365);
		});

		agreeBtn2.addEventListener("click", () => {
			const checkBox = cookieModule.querySelector('[type="checkbox"]');
			cookieModule.classList.remove("is-active");

			if (checkBox.checked === true) {
				checkToken(apiUrl, token, COOKIE_GDPRC, 1, 365);
			} else {
				if (cookiesBelt) {
					cookiesBelt.classList.add("is-active");
				}
			}
		});

		disagreeBtns.forEach((disagreeBtn) => {
			disagreeBtn.addEventListener("click", () => {
				cookieModule.classList.remove("is-active");
				setCookie(COOKIE_GDPRC, 0, 365);
			});
		});

		if (cookiesBelt) {
			const changeOption = cookiesBelt.querySelector('[data-js="change-option"]'),
				delayBtn = cookiesBelt.querySelector('[data-js="delay-btn"]');

			changeOption.addEventListener("click", () => {
				cookieModule.classList.add("is-active", "checkbox");
				cookiesBelt.classList.remove("is-active");
			});

			delayBtn.addEventListener("click", () => {
				sessionStorage.setItem("hide", "true");
				cookiesBelt.classList.remove("is-active");
			});
		}
	}
}

function getTopDomain() {
	return location.hostname.split(".").slice(-2).join(".");
}

function setCookie(name, value, exdays) {
	deleteCookie(name);
	let d = new Date();
	let set = d.toISOString();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	let expires = "expires=" + d.toUTCString();
	let domain = "domain=" + getTopDomain();
	document.cookie =
		name + "=" + value + ";" + expires + ";" + domain + ";path=/";
	document.cookie =
		name + "-set" + "=" + set + ";" + expires + ";" + domain + ";path=/";
	window.location = loc.protocol + "//" + loc.host + loc.pathname + loc.search;
	sessionStorage.clear();
}

function getCookie(cname) {
	let name = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(";");
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function deleteCookie(name, domain, path) {
	let str = name + "=; Max-Age=-99999999;";
	let strset = name + "-set" + "=; Max-Age=-99999999;";
	str += path === undefined ? "path=/;" : "path=" + path + ";";
	strset += path === undefined ? "path=/;" : "path=" + path + ";";

	if (domain !== undefined) {
		document.cookie = str + " domain=" + domain + ";";
		document.cookie = strset + " domain=" + domain + ";";
		return;
	} else {
		document.cookie = str;
		document.cookie = str + " domain=." + location.hostname + ";";
		document.cookie = str + " domain=." + getTopDomain() + ";";
		document.cookie = strset;
		document.cookie = strset + " domain=." + location.hostname + ";";
		document.cookie = strset + " domain=." + getTopDomain() + ";";
	}
}

function checkToken(api, token, name, value, exdays) {
	let xhr = new XMLHttpRequest(),
		tokenString = JSON.stringify(token);

	xhr.open("POST", api, true);
	xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
	xhr.setRequestHeader("Content-Type", "application/json");

	xhr.onreadystatechange = function () {
		if (this.status === 200) {
			setCookie(name, value, exdays);
		}
		window.location = loc.protocol + "//" + loc.host + loc.pathname + loc.search;
	};

	xhr.send(tokenString);
}

function checkCookie(module, belt, pdate) {
	let c = getCookie(COOKIE_GDPRC);
	let cset = getCookie(COOKIE_GDPRC + "-set");
	if (!c) {
		if (module) {
			module.classList.add("is-active");
		}
	} else if (c == 1 || c == 2) {
		module.classList.remove("is-active");
		if (!cset || pdate > cset) {
			module.classList.add("is-active");
		}
	} else if (c == 0) {
		belt.classList.add("is-active");
	}
}

export default popupCookies;
